import { CustomerServicePackageEffectiveStatus } from '../../services/servicePackageService';

export const CURRENT_PACKAGES_FILTER = 'current';
export const ALL_PACKAGES_FILTER = 'all';

export const CUSTOMER_PACKAGE_FILTERS = [
  CURRENT_PACKAGES_FILTER,
  CustomerServicePackageEffectiveStatus.Exhausted,
  CustomerServicePackageEffectiveStatus.Expired,
  CustomerServicePackageEffectiveStatus.Canceled,
  CustomerServicePackageEffectiveStatus.Refunded,
  ALL_PACKAGES_FILTER,
];

export const getCustomerPackageFilterLabelKey = (filter) => {
  if (filter === CURRENT_PACKAGES_FILTER || filter === ALL_PACKAGES_FILTER) {
    return `servicePackagesManagement.customerPackages.filter.${filter}`;
  }

  return `servicePackagesManagement.customer.effectiveStatus.${filter}`;
};

export const filterCustomerServicePackages = (customerPackages, filter) => {
  if (filter === ALL_PACKAGES_FILTER) {
    return customerPackages;
  }

  const effectiveStatus = filter === CURRENT_PACKAGES_FILTER
    ? CustomerServicePackageEffectiveStatus.Active
    : filter;
  return customerPackages.filter((customerPackage) => customerPackage.effectiveStatus === effectiveStatus);
};
